import React, { Component } from 'react'
import update from 'react/lib/update';
import PropTypes from 'prop-types'
import Radium from 'radium';
import Row from './table/row'
import Cell from './table/cell'
import Header from './table/header'
import PicFSUpload from '../../../../Common/picFSUpload';
import { semanticColors } from '../../../../Globals/styles';

const propTypes = {}

const defaultProps = {}

class Invoices extends Component {
    constructor(props) {
        super(props)
        this.state = {
            width: [
                '5%',
                '30%',
                '35%',
                '10%',
                '10%',
                '10%',
            ],
        }
    }
    renderHeader = () => {
        return (
            <Row
            >
                <Header
                    content={'Pos.'}
                    style={{ width: this.state.width[0] }}
                    inputStyle={{
                        textAlign: 'center',
                    }}
                />
                <Header
                    content={'Navn'}
                    style={{ width: this.state.width[1] }}
                />
                <Header
                    content={'Fil'}
                    style={{ width: this.state.width[2] }}
                    inputStyle={{
                        textAlign: 'center',
                    }}
                />
                <Header
                    content={'Pris'}
                    style={{ width: this.state.width[3] }}
                    inputStyle={{ textAlign: 'center' }}
                />
                <Header
                    content={'Tillæg %'}
                    style={{ width: this.state.width[4] }}
                    inputStyle={{ textAlign: 'center' }}
                />
                <Header
                    content={'Sum'}
                    style={{ width: this.state.width[5] }}
                    inputStyle={{ textAlign: 'center' }}
                />
            </Row>
        )
    }
    updateFunction = (key, value, obj, index) => {
        obj[key] = value
        this.props.update(obj, index)
    }
    updateImage = (bilag, index) => {
        this.props.updateBilag(bilag, index)
    }
    parseAndCalcSum(one, two) {
        return (parseFloat(one.toString().replace(',', '.')) * parseFloat(two.toString().replace(',', '.')))
    }
    handleLongFileName = (fileName) => {
        if (fileName.length > 40) {
            return fileName.substring(0, 20) + '...' + fileName.substring(fileName.length - 15, fileName.length);
        }
        return fileName;
    }
    renderContent = (r, index) => {
        let background = index % 2 == 0 ? semanticColors.mainBackground2 : semanticColors.primaryLight
        let fileName = ''
        if (r.bilag) {
            fileName = this.handleLongFileName(r.bilag.name)
        }
        return (
            <Row
                key={index}
            >
                <Cell
                    onChange={(value) => this.updateFunction('pos', value, r, index)}
                    content={r.pos}
                    style={{ width: this.state.width[0] }}
                    inputStyle={{
                        backgroundColor: background,
                        textAlign: 'center',
                    }}
                />
                <Cell
                    onChange={(value) => this.updateFunction('name', value, r, index)}
                    content={r.name}
                    style={{ width: this.state.width[1] }}
                    inputStyle={{
                        backgroundColor: background
                    }}
                />
                {r.bilag ?
                    <Cell
                        content={fileName}
                        style={{ width: this.state.width[2] }}
                        inputStyle={{
                            backgroundColor: background,
                            textAlign: 'center',
                        }}
                    >
                        <div style={{ position: 'relative' }}>
                            {this.props.print ? null :
                                <div
                                    style={{ position: 'absolute', bottom: 9, right: 0 }}
                                    onClick={() => this.props.updateBilag(null, index)}
                                >
                                    <i
                                        style={{ paddingTop: 12 }}
                                        className="fa fa-times-circle"
                                        aria-hidden="true"
                                    />
                                </div>
                            }
                        </div>
                    </Cell> :
                    <div
                        style={{
                            width: this.state.width[2],
                            backgroundColor: background,
                            textAlign: 'center',
                            flexGrow: 0,
                            flexShrink: 0,
                            verticalAlign: 'top',
                        }}

                    >
                        <PicFSUpload
                            className="waves-btn"
                            accept="application/pdf,image/*"
                            style={{ height: 35 }}
                            onFilesSelected={files => {
                                var reader = new FileReader();
                                reader.onload = (function (f) {
                                    return function (e) {
                                        this.props.updateBilag({ file: e.target.result, name: f.name }, index)
                                    };
                                })(files[0]).bind(this);

                                // Read in the image file as a data URL.
                                reader.readAsDataURL(files[0]);
                            }}
                            multiple={false}>
                            {this.props.print ? null :
                                <div
                                    style={{ display: 'flex', justifyContent: 'center' }}>
                                    <i
                                        className="fa fa-file-o"
                                        aria-hidden="true"
                                        style={{ paddingTop: 11 }}
                                    >
                                    </i>
                                    <div
                                        style={{ 'marginTop': '8px', paddingLeft: 5 }}>
                                        Upload fil
                                </div>
                                </div>
                            }
                        </PicFSUpload>
                    </div>
                }
                <Cell
                    onChange={(value) => this.updateFunction('price', value, r, index)}
                    content={r.price}
                    style={{ width: this.state.width[3] }}
                    inputStyle={{
                        backgroundColor: background,
                        textAlign: 'center',

                    }}
                />
                <Cell
                    onChange={(value) => this.updateFunction('til', value, r, index)}
                    content={r.til}
                    style={{ width: this.state.width[4] }}
                    inputStyle={{
                        backgroundColor: background,
                        textAlign: 'center',

                    }}
                />
                <Cell
                    readOnly
                    content={
                        (((r.price ? parseFloat(r.price.toString().replace(',', '.')) : 0) * (((r.til ? parseFloat(r.til.toString().replace(',', '.')) : 0) / 100) + 1) * 100) / 100).toFixed(2).toString().replace('.00', '').replace('.', ',')
                    }
                    style={{ width: this.state.width[5] }}
                    inputStyle={{
                        backgroundColor: background,
                        textAlign: 'center',

                    }}
                />
            </Row>
        )
    }
    render() {
        let total = 0
        let rows = this.props.rows.map((row, index) => {
            total += (((row.price ? parseFloat(row.price.toString().replace(',', '.')) : 0) * (((row.til ? parseFloat(row.til.toString().replace(',', '.')) : 0) / 100) + 1) * 100) / 100)
            return this.renderContent(row, index)
        })

        return (
            <div style={[{ width: '100%' }]}>
                {this.renderHeader()}
                {rows}
                <div style={{ float: 'right', padding: 5, borderBottom: '1px solid ' + semanticColors.primaryLight }}>
                    <div style={{ fontWeight: 600 }}>
                        I alt: {(Math.round(total * 100) / 100).toString().replace('.', ',')}
                    </div>
                </div>
            </div>
        )
    }
}

const styles = {
    flexify: {
        display: 'flex',
        flexDirection: 'row',
    },
    column: {
        flexGrow: 0,
        flexShrink: 0,
        verticalAlign: 'top',
    }
}

Invoices.propTypes = propTypes

Invoices.defaultProps = defaultProps

export default Radium(Invoices)


// WEBPACK FOOTER //
// ./src/App/ShortTermProjects/Workplace/Invoice/spreadsheets/invoices.js